import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {map, takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {FormControl} from "@angular/forms";
import {CentreService} from "../../../../services/centre.service";
import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {EducationService} from "../../education.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSelectChange} from "@angular/material/select";
import {ViewEducationGroupComponent} from "../view-education-group/view-education-group.component";
import firebase from "firebase/compat";
import {AddGroupEducationComponent} from "../add-group-education/add-group-education.component";
import {EditGroupEducationComponent} from "../edit-group-education/edit-group-education.component";
import {needConfirmation} from "../../../../confirm-dialog/confirm-dialog.decorator";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";
import {UserRole} from "../../../../components/rename/add-user-role/add-user-role.component";
import {LogService} from "../../../../services/log.service";
import {EmployeeService} from "../../../../services/employee.service";
import Timestamp = firebase.firestore.Timestamp;
import {loadTranslations} from "@angular-devkit/build-angular/src/utils/i18n-options";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {FinancialYearService} from "../../../../services/financial-year.service";


@Component({
  selector: 'app-education-group-table',
  templateUrl: './education-table-group.component.html',
  styleUrls: ['./education-table-group.component.scss']
})
export class EducationTableGroupComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  sessionTypes = ['Activity Session', 'Regular Study ', 'Special Day'];
  teachers$: Observable<any[]>
  mVolunteer = 'All'
  displayedColumns: string[] = ['sr.no','childrenNames', 'centre', 'sessionDate', 'startTime', 'sessionType', 'subject', 'topicsCovered', 'sessionChildCount', 'submittedBy', 'volunteerName', 'createdAt', 'action'];
  centres$!: Observable<Centre[]>;
  userData: any
  selectedCentre: any
  mFilteredData: any[] = []
  afterFilteringData: any[] = []
  mAllData: any[] = []
  dataSource!: MatTableDataSource<any>;
  isLoading = false;  // New loading flag
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) matSort!: MatSort;
  start: Date | undefined
  end: Date | undefined
  countType: 'bysession' | 'bychildren' = 'bychildren';
  SelectCentre = new FormControl('')
  permissions = JSON.parse(localStorage.getItem('permissions')!) as UserRole[]
  education = this.permissions.filter((x) => x.functionName == 'Education')
  mTeacher: string | null = null
  mSession: string | null = null
  mConductedBy: string = 'All'
  volunteers$:Observable<any>
  constructor(private readonly centreService: CentreService,
              private readonly router: Router,
              private datePipe: DatePipe,
              private readonly mEmployeeService: EmployeeService,
              private educationService: EducationService,
              private readonly _snackBar: MatSnackBar,
              private readonly matDialog: MatDialog,
              private readonly mLogService: LogService,
              private mDatabase : AngularFireDatabase,
              private readonly financialYearService: FinancialYearService
  ) {
    this.teachers$ = this.mEmployeeService.getTeachers()
    this.userData = JSON.parse(localStorage.getItem('userData')!)
    const sortByName = map((centres: Centre[]) => [...centres].sort((a, b) => (a.centreName ?? '').trim().localeCompare((b.centreName ?? '').trim())));
    if (this.userData.role == 'Centre') {
      this.centres$ = centreService.getSortedCenterListByRole(this.userData.centreCode).pipe(sortByName)
    } else if (this.userData.role != 'Centre') {
      this.centres$ = centreService.getAllCentres().pipe(sortByName)
    }
    this.dataSource = new MatTableDataSource(this.mFilteredData);
    this.dataSource.sort = this.matSort
    this.volunteers$ = this.mDatabase.list('types/Volunteers').valueChanges()
  }

  get totalSessionChildCount(): number {
    const data = this.dataSource?.filteredData;

    if (!data?.length) {
      return 0;
    }
    return data.reduce((total, session: any) => {

      // bychildren → count children length
      if (session.countType === 'bychildren') {
        return total + (session.children?.length || 0);
      }
      // countType is '' / undefined / bysession / anything else → count as 1
      return total ;

    }, 0);
  }

  get teacherCount(): number {
    return this.dataSource?.filteredData?.filter(x => x.conductedBy === 'By Teacher').length || 0;
  }

  clearAll() {
    this.mTeacher = null
    this.mSession = null
    this.mConductedBy = 'All'
    // Reset date range back to the current financial year
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;

    // Reset selected centre
    this.selectedCentre = undefined;
    this.SelectCentre.setValue('');

    // Clear education data
    this.mFilteredData = [];
    this.afterFilteringData = [];
    this.dataSource.data = [];

    // Reset pagination and sorting
    this.paginator.firstPage();
    this.matSort.active = '';
    this.matSort.direction = '';
  }

  ngOnInit(): void {
    // Pre-fill the date range with the current financial year (search still requires an explicit click)
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.start = fy.startDate;
    this.end = fy.endDate;
  }

  AddIndividualSession() {

  }

  AddGroupSession() {
    // this.router.navigateByUrl('add-individual-education')
    this.matDialog.open(AddGroupEducationComponent, {
      width: '800%',

      height: '90%'
    })
  }

  fetchByCenter($event: MatSelectChange) {
    console.log('FETCH CENTER SELECTED IN EDUCATION')
    // this.start =undefined
    // this.end =undefined
    let c = $event.value
    this.selectedCentre = {
      centreName: c.centreName,
      centreCode: c.centreCode
    }
//     this.educationService.getGroupEducationSessions($event.value.centreCode,this.selectedCentre).subscribe(re => {
//       this.mFilteredData = re
//         this.mFilteredData.forEach(session=>{
//         let children :string[]= []
//            session.children.forEach((it: { childName: any; })=>{
//                 children.push(' '+it.childName)
//             })
// session.children = children
//         })
//       this.dataSource = new MatTableDataSource(this.mFilteredData);
//       this.dataSource.sort =this.matSort
//       this.dataSource.paginator = this.paginator;
//
//       console.log(this.mFilteredData)
//     })

  }

  search() {
    if (!this.selectedCentre) {
      this._snackBar.open('Please select a centre first', '', {
        duration: 3000,
        panelClass: 'error'
      });
      return;
    }
    this.isLoading = true;  // Start loading
    this.educationService.getGroupEducationSessions(this.selectedCentre.centreCode, this.selectedCentre,this.mVolunteer)
      .pipe(takeUntil(this._destroyed$))
      .subscribe(re => {


        this.mAllData = [...re]; // Spread operator for immutability
        this.mFilteredData = re.map(session => { // Use map for creating new objects
          const children = session.children.map((it: { childName: any; }) => it.childName).join(' '); // Efficient children processing
          return {...session, childrenNames: children}; // Spread operator for extending session object
        });
        console.log("this.mFilteredData", this.mFilteredData)

        // Filter by date (if applicable)
        if (this.start && this.end) {
          // alert('filtering by date')
          console.log(`searching by date: ${this.mFilteredData.length} ${this.start} ${this.end}`); // Informative message

          this.mFilteredData = this.mFilteredData.filter(session =>
            session.sessionDate.toDate() >= this.start!! && session.sessionDate.toDate() <= this.end!!
          )
        } else {

        }

        this.dataSource = new MatTableDataSource(this.mFilteredData);
        this.filterData(); // Assuming filtering is independent of dates
        this.dataSource.sort = this.matSort;
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;  // Start loading
        console.log(this.mFilteredData.length);
      });

  }



  downloadExcel() {
    const tableData = this.dataSource.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource.data;

    if (!tableData || tableData.length === 0) {
      alert('No data available to download');
      return;
    }

    let excelContent = `
    <table border="1">
      <tr>
        <th>Sr.No</th>
        <th>Children Names</th>
        <th>Centre</th>
        <th>Session Date</th>
        <th>Timing</th>
        <th>Session Type</th>
        <th>Subject</th>
        <th>Topics Covered</th>
        <th>Remark</th>
        <th>Teacher</th>
        <th>Volunteer</th>
        <th>Created At</th>
        <th>Status</th>
      </tr>
  `;

    tableData.forEach((x: any, index: number) => {
      excelContent += `
      <tr>
        <td>${index + 1}</td>
        <td>${x.childrenNames ?? '-'}</td>
        <td>${this.getCentresString(x.centres) ?? '-'}</td>
        <td>${x.sessionDate ? this.getDate(x.sessionDate) : '-'}</td>
        <td>${x.startTime ? this.getTime(x.startTime) : '-'}</td>
        <td>${x.sessionType ?? '-'}</td>
        <td>${x.subject ?? '-'}</td>
        <td>${x.topicsCovered ?? '-'}</td>
        <td>${x.remark ?? '-'}</td>
        <td>${x.submittedBy ?? '-'}</td>
        <td>${x.volunteerName ?? '-'}</td>
        <td>${x.createdAt ? this.getDateandTime(x.createdAt) : '-'}</td>
        <td>${x.status ?? 'Pending'}</td>
      </tr>
    `;
    });

    excelContent += `</table>`;

    const blob = new Blob(
      ['\ufeff' + excelContent],
      { type: 'application/vnd.ms-excel;charset=utf-8;' }
    );

    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `Education_Group_Sessions_${Date.now()}.xls`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }


  getDate(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy');
    return datePipeString
  }

  getTime(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, "HH:mm:aa");
    return datePipeString
  }

  viewDialog(element: any) {
    this.matDialog.open(ViewEducationGroupComponent, {
      data: element,
      width: '800%',
      autoFocus: false,

      height: '90%'
    })

  }

  getCentresString(centres: any) {
    let arr: any[] = []
    centres.forEach((it: { centreName: any; }) => {
      arr.push(it.centreName)
    })
    return arr
  }

  getChildrenString(children: any) {
    let arr: any[] = []
    children.forEach((it: { childName: any; }) => {
      arr.push(' ' + it.childName)
    })
    return arr
  }

  getDateandTime(date: Date): any {
    let d = (date as unknown as Timestamp).toDate()
    let datePipeString = this.datePipe.transform(d, 'dd-MMM-yyyy h:mm a ');
    return datePipeString
  }


  viewEdit(element: any) {
    this.matDialog.open(EditGroupEducationComponent, {
        data: element,
        autoFocus: false,
      disableClose: true  , // <-- ADD THIS

        width: '800%',
        height: '90%'
      }
    )
  }

  @needConfirmation()
  delete(element: any) {
    this.educationService.deleteGroupSession(element).then(() => {
      this._snackBar.open('Deleted Successfully!')._dismissAfter(3000)
      let activity = {
        date: new Date().getTime(),
        section: 'Group Education',
        action: 'Delete',

        description: `Session Deleted in Education by`,
        currentIp: localStorage.getItem('currentip')!
      }
      this.mLogService.addLog(activity)
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  filterData() {
    this.afterFilteringData = this.mFilteredData

    if (this.mTeacher != 'All' && this.mTeacher != null) {
      this.afterFilteringData = this.afterFilteringData.filter(x => x.submittedBy == this.mTeacher)
      console.log('after filtering', this.mTeacher)
    }
    if (this.mSession != 'All' && this.mSession != null) {
      this.afterFilteringData = this.afterFilteringData.filter(x => x.sessionType == this.mSession)
      console.log('after filtering', this.mSession + 'x')
    }
    if (this.mConductedBy === 'teacher') {
      this.afterFilteringData = this.afterFilteringData.filter(x => x.submittedBy && x.submittedBy.trim() !== '')
    } else if (this.mConductedBy === 'volunteer') {
      this.afterFilteringData = this.afterFilteringData.filter(x => x.volunteerName && x.volunteerName.trim() !== '')
    }
    this.dataSource.data = this.afterFilteringData
    this.isLoading = false;  // Start loading
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
